import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18TrashG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
      fillRule: "evenodd",
      d: "M15.318 4.227a.682.682 0 0 1 0 1.364l-.464-.001-.825 10.285a.67.67 0 0 1-.553.617l-.101.008h-8.75a.66.66 0 0 1-.638-.522l-.016-.103L3.146 5.59h-.464a.682.682 0 0 1 0-1.363zm-1.782 1.364H4.463l.766 9.545h7.541zM7.25 6.727c.362 0 .656.294.656.657v5.96a.656.656 0 0 1-1.312 0v-5.96c0-.363.294-.657.656-.657m3.5 0c.362 0 .656.294.656.657v5.96a.656.656 0 0 1-1.312 0v-5.96c0-.363.294-.657.656-.657M11.818 1.5a.682.682 0 1 1 0 1.364H6.182a.682.682 0 0 1 0-1.364z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18TrashG$1 = Svg18TrashG;

export { Svg18TrashG$1 as default };
